import type { FieldValues } from "react-hook-form"

import { objectEntries } from "~/utils/object-entries"
import { objectValues } from "~/utils/object-values"

export function getFiltersAmount(filters: FieldValues) {
  return (
    objectEntries(filters ?? {})?.reduce((acc, [key, current]) => {
      if (key === "sort") {
        return acc
      }

      return acc + objectValues(current)?.filter(Boolean)?.length
    }, 0) ?? 0
  )
}
